import React from 'react';
import { Link } from 'react-router-dom';

const SecurityPage = () => (
  <div className="min-h-screen bg-[#0a0a0a] text-white p-8 sm:p-16">
    <nav className="mb-16 text-center">
      <Link to="/" className="inline-flex items-center gap-2 no-underline">
        <span className="text-2xl sm:text-3xl">🕵️</span>
        <span className="text-2xl sm:text-3xl font-bold text-[#e07a5f]">WhyDidItDie</span>
      </Link>
    </nav>
    <div className="w-full max-w-screen-sm sm:max-w-screen-md mx-auto text-center">
      <h1 className="text-4xl sm:text-5xl font-bold mb-8 text-[#e07a5f]">Security</h1>
      <div className="bg-white/5 p-8 rounded-xl mb-8 border border-white/10">
        <p className="text-base sm:text-lg font-bold mb-4 flex items-center justify-center gap-2">
          🔒 <span>Enterprise-grade security</span>
        </p>
        <p className="text-base sm:text-lg text-white/90 mb-4">
          We take your data seriously. All integrations, API endpoints, and user sessions are secured using SSL encryption, token authentication, and role-based access control.
        </p>
        <p className="text-base sm:text-lg font-bold mb-4 flex items-center justify-center gap-2">
          🛡 <span>SOC 2 readiness</span>
        </p>
        <p className="text-base sm:text-lg text-white/90 mb-4">
          Our infrastructure and workflows are built with SOC 2 compliance in mind — audit logs, data access tracking, and continuous monitoring are baked into our systems.
        </p>
        <p className="text-base sm:text-lg font-bold mb-4 flex items-center justify-center gap-2">
          📊 <span>End-to-end encryption</span>
        </p>
        <p className="text-base sm:text-lg text-white/90">
          Whether you’re syncing ad accounts or reviewing diagnostics, your data is encrypted in transit and at rest using industry best practices.
        </p>
      </div>
      <Link to="https://app.whydiditdie.com" className="text-[#e07a5f] text-base sm:text-lg no-underline hover:text-[#ff6b6b] transition-colors">
        ← Back to Home
      </Link>
    </div>
    <footer className="py-8 px-4 sm:px-8 border-t border-white/10 mt-16">
      <div className="w-full max-w-screen-sm mx-auto text-center">
        <h4 className="text-base font-bold text-white mb-4">Follow Us</h4>
        <div className="grid grid-cols-2 gap-3 sm:flex sm:flex-wrap sm:gap-4 justify-center">
          <a
            href="https://www.instagram.com/ai_whydiditdie"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 p-2 bg-white/10 rounded-lg border border-white/20 hover:bg-[#e07a5f]/20 hover:border-[#e07a5f]/50 transition-all"
          >
            <svg className="w-5 h-5 text-[#e07a5f] group-hover:text-[#ff6b6b]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.326 3.608 1.301.975.975 1.24 2.242 1.301 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.326 2.633-1.301 3.608-.975.975-2.242 1.24-3.608 1.301-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.326-3.608-1.301-.975-.975-1.24-2.242-1.301-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.326-2.633 1.301-3.608.975-.975 2.242-1.24 3.608-1.301 1.266-.058 1.646-.07 4.85-.07m0-2.163c-3.259 0-3.667.014-4.947.072-1.524.069-2.978.377-4.103 1.502-1.125 1.125-1.433 2.579-1.502 4.103-.058 1.28-.072 1.688-.072 4.947s.014 3.667.072 4.947c.069 1.524.377 2.978 1.502 4.103 1.125 1.125 2.579 1.433 4.103 1.502 1.28.058 1.688.072 4.947.072s3.667-.014 4.947-.072c1.524-.069 2.978-.377 4.103-1.502 1.125-1.125 1.433-2.579 1.502-4.103.058-1.28.072-1.688.072-4.947s-.014-3.667-.072-4.947c-.069-1.524-.377-2.978-1.502-4.103-1.125-1.125-2.579-1.433-4.103-1.502-1.28-.058-1.688-.072-4.947-.072z"/>
              <path d="M12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8z"/>
              <circle cx="18.406" cy="5.594" r="1.44"/>
            </svg>
            <span className="text-sm text-white/90 group-hover:text-[#ff6b6b]">@ai_whydiditdie</span>
          </a>
          <a
            href="https://x.com/whydiditdie"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 p-2 bg-white/10 rounded-lg border border-white/20 hover:bg-[#e07a5f]/20 hover:border-[#e07a5f]/50 transition-all"
          >
            <svg className="w-5 h-5 text-[#e07a5f] group-hover:text-[#ff6b6b]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zM16.62 20.61h2.048L7.353 3.39H5.154l11.466 17.22z"/>
            </svg>
            <span className="text-sm text-white/90 group-hover:text-[#ff6b6b]">@whydiditdie</span>
          </a>
          <a
            href="https://www.facebook.com/whydiditdie"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 p-2 bg-white/10 rounded-lg border border-white/20 hover:bg-[#e07a5f]/20 hover:border-[#e07a5f]/50 transition-all"
          >
            <svg className="w-5 h-5 text-[#e07a5f] group-hover:text-[#ff6b6b]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            <span className="text-sm text-white/90 group-hover:text-[#ff6b6b]">@whydiditdie</span>
          </a>
          <a
            href="https://www.tiktok.com/@app.whydiditdie"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 p-2 bg-white/10 rounded-lg border border-white/20 hover:bg-[#e07a5f]/20 hover:border-[#e07a5f]/50 transition-all"
          >
            <svg className="w-5 h-5 text-[#e07a5f] group-hover:text-[#ff6b6b]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69c-.93-.91-2.17-1.49-3.54-1.62v-2.1h-2.64v11.28c0 1.38-1.12 2.5-2.5 2.5s-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5c.24 0 .47.04.69.11v-2.88c-.22-.02-.44-.03-.67-.03-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5V8.64c1.33.53 2.81.84 4.31.84V6.69z"/>
            </svg>
            <span className="text-sm text-white/90 group-hover:text-[#ff6b6b]">@app.whydiditdie</span>
          </a>
        </div>
      </div>
    </footer>
  </div>
);

export default SecurityPage;